<template>
  <PopUp
    class="delete-modal-wrapper"
    :show="show"
    @cancel="$emit('cancel')"
    @complete="$emit('delete')"
  >
    <template v-slot:header>
      <Icon class="delete-icon">mdi-delete</Icon>
      <slot name="header"></slot>
    </template>
    <template v-slot:content>
      <slot name="content"></slot>
    </template>
    <template v-slot:cancel>
      <slot name="cancel"></slot>
    </template>
    <template v-slot:complete>
      <slot name="complete"></slot>
    </template>
  </PopUp>
</template>

<script>
import { PopUp, Icon } from '@mikmak/components';

export default {
  components: {
    PopUp,
    Icon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleComplete() {
      this.$emit('deleteReportRow');
    },
  },
};
</script>
<style scoped lang="scss">
.delete-modal-wrapper::v-deep {
  .modal {
    height: 276px;
  }

  .modal .delete-icon {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .modal .delete-icon i.mdi-delete {
    font-size: 50px;
    margin-bottom: 22px;
  }

  .actions-wrapper {
    background: none;
    padding-bottom: 10px;
  }
}
</style>
